type EventHandler = (event: Event) => void;

export function handlers(...args: EventHandler[]) {
  return (event: Event) => {
    args.forEach(handler => {
      // Don't let an error on one handler stop the execution of the rest
      try {
        handler(event);
      } catch (err) {
        console.error('Error caught while running event handler:', err);
      }
    });
  }
}